import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  InputNumber,
  Row,
  Col,
  Card,
  Switch,
  Select,
  Collapse,
  Space,
  DatePicker,
} from "antd";
import { UserService } from "../../../Services/Manage/UserService";
import { GeneralService } from "../../../Services/General/GeneralService";
import { DownOutlined } from "@ant-design/icons";
import { DepartmentEmpServices } from "../../../Services/Manage/DepartmentEmpServices";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";

const CreateUser = ({ initialValues, onSubmit, onCancel, handleEQNo, form }) => {
  // const [form] = Form.useForm();
  const [enquiryNo, setEnquiryNo] = useState('');
  const [lastId, setLastId] = useState([]);
  const [roleOption, setRoleOption] = useState([]);
  const [dptOption, setDptOption] = useState([]);

  const { Panel } = Collapse;

  const handleFinish = async (values) => {
    try {
      const payload = {
        ...values,
        id: initialValues?.id,
        status: values.status ? "Active" : "Inactive",
      };
      onSubmit(payload);
      form.resetFields();
    } catch (error) {
      console.error("User operation failed:", error);
    }
  };

  console.log('initialValues', initialValues);

  const getLastReg = async () => {
    try {
      const request = await UserService.getLastUsers();
      console.log(request);
      setLastId(request.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getAllRole = async () => {
    try {
      const request = await GeneralService.getAllRole();

      const options = request.data
        .filter(item => item.status === "Active")
        .map(item => ({
          value: item.name,
          label: item.name,
        }));

      setRoleOption(options);
    } catch (error) {
      console.log(error);
    }
  };

  const getAllDepartment = async () => {
    try {
      const request = await DepartmentEmpServices.getAllDepartment();

      const options = request.data
        .filter(item => item.status === "Active")
        .map(item => ({
          value: item.id,
          label: item.name,
        }));

      setDptOption(options);
    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    getAllRole();
    getAllDepartment();

    const statusValue = initialValues?.status === "Active" || !initialValues?.status;
    const valuesToSet = {
      ...initialValues,
      date_of_join: initialValues?.date_of_join ? dayjs(initialValues.date_of_join, 'DD-MM-YYYY') : null,
      date_of_birth: initialValues?.date_of_birth ? dayjs(initialValues.date_of_birth, 'DD-MM-YYYY') : null,
      status: !!statusValue,
    };

    form.setFieldsValue(valuesToSet);
    if (initialValues?.uid) {
      setEnquiryNo(initialValues.uid);
    }
  }, [initialValues]);

  useEffect(() => {
    if (!initialValues?.uid) {
      getLastReg();
    }
  }, [initialValues]);

  useEffect(() => {
    if (lastId && !initialValues?.uid) {
      generateEnquiryNo();
    }
  }, [lastId]);

  const generateEnquiryNo = () => {
    const now = new Date();
    const day = now.getDate().toString().padStart(2, "0");
    const month = (now.getMonth() + 1).toString().padStart(2, "0");
    const currentPrefix = `${day}${month}`;

    let nextNumber = "0001";

    if (lastId?.uid) {
      const lastPrefix = lastId.uid.split("-")[0];
      if (lastPrefix === currentPrefix) {
        const numericPart = lastId.uid.split("-")[1] || "0000";
        nextNumber = String(Number(numericPart) + 1).padStart(4, "0");
      }
    }

    const newEnquiryNo = `${currentPrefix}-${nextNumber}`;
    setEnquiryNo(newEnquiryNo);
    handleEQNo(newEnquiryNo);
    form.setFieldsValue({ uid: newEnquiryNo });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        <Collapse
          expandIconPosition='end'
          size="large"
          defaultActiveKey={["1"]}
          expandIcon={({ isActive }) => (
            <DownOutlined
              rotate={isActive ? 180 : 0}
            />
          )}
        >
          <Panel header="Basic details" key="1">

            <Row gutter={[16, 16]}>

              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  name="job_title"
                  label="Job title"
                >
                  <Input size="large" maxLength={40} placeholder="Enter job title" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  name="name"
                  label="Name"
                  rules={[{ required: true, message: "Please enter name" }]}
                >
                  <Input size="large" placeholder="Enter name" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    { required: true, message: "Please enter email" },
                    { type: "email", message: "Please enter a valid email" },
                  ]}
                >
                  <Input size="large" placeholder="Enter email" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  name="phone"
                  label="Phone"
                  rules={[
                    { required: true, message: "Please enter phone number" },
                    {
                      pattern: /^[0-9]{1,15}$/,
                      message: "Phone must be numbers only (max 15 digits)",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    maxLength={15}
                    placeholder="Enter phone number"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  name="department_id"
                  label="Department"
                >
                  <Select
                    options={dptOption}
                    showSearch
                    size="large"
                    placeholder="Select department"
                  />
                </Form.Item>
              </Col>


              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  name="role"
                  label="Role"
                  rules={[{ required: true, message: "Please select role" }]}
                >
                  <Select
                    showSearch
                    options={roleOption}
                    value={initialValues?.department_id}
                    size="large"
                    placeholder="Select role"
                  />
                </Form.Item>
              </Col>

            </Row>

          </Panel>
        </Collapse>


        <Collapse
          expandIconPosition='end'
          size="large"
          expandIcon={({ isActive }) => (
            <DownOutlined
              rotate={isActive ? 180 : 0}
            />
          )}
        >
          <Panel header="Additional Details" key="1">
            <Row gutter={[16, 16]}>


              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  name="date_of_join"
                  label="Date of Join"
                >
                  <DatePicker
                    value={dayjs()}
                    format="DD-MM-YYYY"
                    style={{ width: '100%' }} size="large" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  name="gender"
                  label="Gender"
                >
                  <Select
                    placeholder="Select Gender"
                    size="large"
                  >
                    <Select.Option value="Male">Male</Select.Option>
                    <Select.Option value="Female">Female</Select.Option>
                    <Select.Option value="Other">Other</Select.Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  name="date_of_birth"
                  label="Date of Birth"
                >
                  <DatePicker
                    value={dayjs()}
                    format="DD-MM-YYYY"
                    style={{ width: '100%' }} size="large" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  name="relationship_status"
                  label="Marital Status"

                >
                  <Select
                    placeholder="Select Marital Status"
                    style={{ width: '100%' }}
                    size="large"
                  >
                    <Select.Option value="Married">Married</Select.Option>
                    <Select.Option value="Unmarried">Unmarried</Select.Option>
                    <Select.Option value="Other">Other</Select.Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  name="blood_group"
                  label="Blood Group"

                >
                  <Input
                    size="large"
                    maxLength={15}
                    placeholder="Enter Blood Group"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  name="address"
                  label="Address"
                >
                  <TextArea
                    size="large"
                    maxLength={50}
                    placeholder="Enter Address"
                  />
                </Form.Item>
              </Col>

            </Row>
          </Panel>
        </Collapse>

        <Collapse
          expandIconPosition='end'
          size="large"
          expandIcon={({ isActive }) => (
            <DownOutlined
              rotate={isActive ? 180 : 0}
            />
          )}
        >
          <Panel header="Bank & Payroll" key="1">
            <Row gutter={[16, 16]}>

              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  name="bank_name"
                  label="Bank Name"
                >
                  <Input
                    size="large"
                    placeholder="Enter Bank Name"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  name="ac_holder_name"
                  label="Bank Account Holder Name"
                >
                  <Input
                    size="large"
                    placeholder="Enter Bank Account Holder Name"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  name="bank_ac"
                  label="Bank Account Number"
                >
                  <Input
                    size="large"
                    placeholder="Enter Bank Account Number"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  name="ifsc"
                  label="Bank IFSC Code"
                >
                  <Input
                    size="large"
                    placeholder="Enter Bank IFSC Code"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  name="aadhar"
                  label="Aadhar / SSN"
                >
                  <Input
                    size="large"
                    placeholder="Enter Aadhar / SSN"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  name="pan"
                  label="PAN / Tax ID"
                >
                  <Input
                    size="large"
                    placeholder="Enter PAN / Tax ID"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  name="passport_number"
                  label="Passport Number"
                >
                  <Input
                    size="large"
                    placeholder="Enter Passport Number"
                  />
                </Form.Item>
              </Col>

            </Row>
          </Panel>
        </Collapse>

        <Collapse
          expandIconPosition='end'
          size="large"
          expandIcon={({ isActive }) => (
            <DownOutlined
              rotate={isActive ? 180 : 0}
            />
          )}
        >
          <Panel header="Other details" key="1">
            <Row gutter={[16, 16]}>

              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  name="education_qualification"
                  label="Last Education Qualification"
                >
                  <TextArea
                    size="large"
                    maxLength={50}
                    placeholder="Enter Last Education Qualification"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  name="previous_employer_details"
                  label="Previous Employer Details"
                >
                  <TextArea
                    size="large"
                    maxLength={50}
                    placeholder="Enter Previous Employer Details"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Panel>
        </Collapse>

      </Space>

      <div style={{ textAlign: "right", marginTop: 24 }}>
        <Button onClick={onCancel} style={{ marginRight: 8 }} size="large">
          Cancel
        </Button>
        <Button type="primary" htmlType="submit" size="large">
          {initialValues?.id ? "Update" : "Create"}
        </Button>
      </div>
    </Form>
  );
};

export default CreateUser;